import { FlaskConical } from "lucide-react";
import { isTestInstance } from "../../lib/environment";
import styles from "./EnvironmentBanner.module.css";

/**
 * The words that go with the test palette (tokens.css, `:root[data-env]`) on
 * pages WITHOUT a top bar: the login page, the public registration and the
 * printed startovní listina. Rendered above the router and hidden by its CSS
 * wherever the shell is mounted, where EnvironmentChip in the top bar says it
 * instead without pushing the page down. Not dismissable; a tester who
 * forgets which system they are in is the failure it exists to prevent.
 */
export function EnvironmentBanner({ show = isTestInstance }: { show?: boolean }) {
  if (!show) return null;
  return (
    <div className={styles.banner} role="note" data-testid="environment-banner">
      <FlaskConical size={16} aria-hidden="true" />
      <strong className={styles.label}>Testovací prostředí</strong>
      <span className={styles.text}>
        Změny se nepromítnou do ostrého systému a e-maily se neodesílají.
      </span>
    </div>
  );
}
